var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgHandicapDebut(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M0 5h20v11H0V5zm3.84 2.3H2.12v6.42h1.72v-2.54h2.1v2.54h1.7V7.3h-1.7v2.37h-2.1V7.3zm9.8 6.26l-.24-1.34c-.26.1-.73.2-1.15.2-1.18 0-1.88-.73-1.88-1.9 0-1.32.86-1.9 1.85-1.9a3.25 3.25 0 011.19.23l.33-1.35c-.27-.15-.87-.3-1.6-.3-1.9 0-3.57 1.15-3.57 3.42 0 1.7 1.06 3.2 3.46 3.2.77 0 1.37-.16 1.62-.27zm2.58-4.52v4.68h1.66v-6.2h-1.4l-1.76.78.27 1.27 1.22-.54h.02z",
    fill: "#010101"
  })));
}
export default SvgHandicapDebut;